import { createSlice } from "@reduxjs/toolkit";
import { SUPERVISOR_CONTACT_DATA } from "../../../constants/reducer_names";
   
const initialState = {
  contactList1: [] as any, 
  contactConstants: [] as any,
  blocked_contacts: [] as any,
  blocked_contactsRequest: [] as any,
  dnd_contacts: [] as any,
  dnd_contactsRequest:[] as any,
  edit_column_data: [] as any,
  edit_column_db_data: [] as any,
  edit_columns1: [] as any,
  currentFormData:{} as any,
  currentCustomerData:{} as any,
  aditionalColumn:[] as any,
  aditionalColumnCall : true,
  dataSource :[] as any,
  total_edit_data: [
     {
       title: "First Name",
       dataIndex: "firstname",
       key: "firstname",
       sorter: (a: any, b: any) => a.firstname.localeCompare(b.firstname),
     },
     {
       title: "Last Name",
       dataIndex: "lastname",
       key: "lastname",
       sorter: (a: any, b: any) => a.lastname.localeCompare(b.lastname),
     },
     {
       title: "Type",
       dataIndex: "type",
       key: "type",
       sorter: (a: any, b: any) => a.type.localeCompare(b.type),
     },
     {
       title: "Phone Number",
       dataIndex: "phonenumber",
       key: "phonenumber",
       sorter: (a: any, b: any) => a.phonenumber - b.phonenumber,
     },
     {
       title: "Email Id",
       dataIndex: "emailid",
       key: "emailid",
       sorter: (a: any, b: any) => a.emailid.localeCompare(b.emailid),
     },
   ] as any,
  set_array: [] as any,
  select_count: 0 as any,
  edit_contact: {},
  set_show_page: true,
  contactRefresh:false,

  blocked_contacts2: [] as any,
  dnd_contacts2: [] as any,
  edit_column_data2: [] as any,
  edit_column_db_data2: [] as any,
  total_edit_data2: [
    {
      title: 'User name',
      dataIndex: 'name',
      key: 'Fname',    
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: 'Phone Number',
      dataIndex: 'number',
      key: 'number',
    },
    {
      title: 'Email ID',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: '',
      dataIndex: 'onhover',
      key: 'onhover',
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
  
    }, ] as any,
  newContactList : [] as any,
  newTableEntry : [] as any,
  titleMapper_r:{
    name: 'User Name',
    action: "Action",
    emailid: "Email Id",
    onhover: 'Onhover',
    type: "Type",
    phonenumber: "Phone Number",
    tags: "Tags",
    location: "Location",
    address: "Address",
    city: "City",
    state: "State",
    country: "Country",
    postalcode: "Postal Code",
    facebook: "Facebook",
    instagram: "Instagram",
    whatsapp: "WhatsApp",
    twitter: "Twitter",
    id: "Customer Id",
    Source:"Source"
  } as any,
  titleMapperForDbs_r : {
    "User Name": "name",
    "Action": "action",
    "Email Id": "emailid",
    "Onhover": 'onhover',
    Type: "type",
    "Phone Number": "phonenumber",
    Tags: "tags",
    Location: "location",
    Address: "address",
    City: "city",
    State: "state",
    Country: "country",
    "Postal Code": "postalcode",
    Facebook: "facebook",
    Instagram: "instagram",
    WhatsApp: "whatsapp",
    Twitter: "twitter",
    "Customer Id": "id",
     Source:"Source"
  } as any,
  newContactTotal: 0,
  oldContactTotal: 0
};
 
const supervisorContactDataSlice: any = createSlice({
  name: SUPERVISOR_CONTACT_DATA,
  initialState,
  reducers: {
    supervisorContactReport: (state, { payload }) => {
      state.contactConstants = payload.contactConstants || [];
      if(payload?.contactList1){
        state.contactList1 = payload.contactList1;
      }else if(payload.newContactList){
        state.newContactList = payload.newContactList;
      }
    },

    updateContact: (state, { payload }) => {
      const index = payload.selectedIndex;
      const updateValue = payload.updateValue;
      state.contactList1[index] = updateValue;
      state.contactConstants[index] = updateValue;
    },
    createContact: (state, { payload }) => {
      state.contactList1 = payload;
      state.contactConstants = payload;
    },
    blockedContacts: (state, { payload }) => {
      state.blocked_contacts = payload.blocked_contacts;
      state.blocked_contacts2 = payload.blocked_contacts2;
    }, 
    blockedContactsRequest: (state, { payload }) => {
      state.blocked_contactsRequest = payload.blocked_contactsRequest; 
    },
   
    dndContacts: (state, { payload }) => {
      state.dnd_contacts = payload.dnd_contacts;
      state.dnd_contacts2 = payload.dnd_contacts2;
    },
    dndContactsRequest: (state, { payload }) => {
      state.dnd_contactsRequest = payload.dnd_contactsRequest; 
    },

    editColumnData: (state, { payload }) => {
      state.edit_column_data = payload.edit_column_data;
    },
    editColumnData2: (state, { payload }) => {
      state.edit_column_data2 = payload.edit_column_data2;
    },
    editColumnDbData: (state, { payload }) => {
      state.edit_column_db_data = payload.edit_column_db_data;
    },
    editColumnDbData2: (state, { payload }) => {
      state.edit_column_db_data2 = payload.edit_column_db_data2;
    },
    editColumns1: (state, { payload }) => {
      state.edit_columns1 = payload.edit_columns1;
    },
    totalEditColumnData: (state, { payload }) => {
      state.total_edit_data = payload.total_edit_data;
    },
    totalEditColumnData2: (state, { payload }) => {
      state.total_edit_data2 = payload.total_edit_data2;
    },
    setArray: (state, { payload }) => {
      state.set_array = payload.set_array;
    },
    selectCount: (state, { payload }) => {
      state.select_count = payload.select_count;
    },
    editContact: (state, { payload }) => {
      state.edit_contact = payload.edit_contact;
    },
    setShowForEditPage: (state, { payload }) => {
      state.set_show_page = payload.set_show_page;
    },
    setContactRefresh:(state)=>{
      state.contactRefresh=!state.contactRefresh
    },
    setFormData: (state, { payload }) => {
      state.currentFormData = payload;
    },
    setCurrentCustomerData: (state, { payload }) => {
      state.currentCustomerData = payload;
    },
    setAditionalColumn :(state,{payload})=>{
      state.aditionalColumn = payload;
    },
    setAditionalColumnCall :(state,{payload})=>{
      state.aditionalColumnCall = payload;
    },
    setDataSourceForTable :(state,{payload})=>{
      state.dataSource = payload;
    },
    setNewTableEntry :(state,{payload})=>{
      state.newTableEntry =payload;
    },
    settitleMapper_r :(state,{payload})=>{
      state.titleMapper_r =payload;
    },
    settitleMapperForDbs_r :(state,{payload})=>{
      state.titleMapperForDbs_r =payload;
    },
    setNewContactTotalcount :(state,{payload})=>{
      state.newContactTotal =payload;
    },
    setOldContactTotalcount :(state,{payload})=>{
      state.oldContactTotal =payload;
    },
    reset: () => {},
  },
});

export const supervisorContactDataSliceActions = supervisorContactDataSlice.actions;
export const supervisorContactDataSliceReducer = supervisorContactDataSlice.reducer;
